export enum OidcEvents {
  AccessTokenExpired = 'addAccessTokenExpired',
  AccessTokenExpiring = 'addAccessTokenExpiring',
  SilentRenewError = 'AddSilentRenewError',
  UserLoaded = 'addUserLoaded',
  UserUnloaded = 'addUserUnloaded',
  UserSignedOut = 'addUserSignedOut',
  UserSessionChanged = 'addUserSessionChanged'
}
